var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as PIXI from 'pixi.js';
import fontkit from 'fontkit-next';
export var FONT_STATUS;
(function (FONT_STATUS) {
    FONT_STATUS[FONT_STATUS["ADDED"] = 0] = "ADDED";
    FONT_STATUS[FONT_STATUS["LOADING"] = 1] = "LOADING";
    FONT_STATUS[FONT_STATUS["LOADED"] = 2] = "LOADED";
    FONT_STATUS[FONT_STATUS["FAILED"] = 3] = "FAILED";
})(FONT_STATUS || (FONT_STATUS = {}));
;
var VERBOSE = false;
var FontLoader = /** @class */ (function (_super) {
    __extends(FontLoader, _super);
    function FontLoader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sourceUrl = undefined;
        _this.font = undefined;
        _this.status = FONT_STATUS.ADDED;
        return _this;
    }
    FontLoader.prototype.load = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, buffer, _a, _b, blob, font, e_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.status = FONT_STATUS.LOADING;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 8, , 9]);
                        return [4 /*yield*/, fetch(this.sourceUrl)];
                    case 2:
                        response = _c.sent();
                        buffer = void 0;
                        if (!(typeof response.arrayBuffer === 'function')) return [3 /*break*/, 4];
                        _b = (_a = Buffer).from;
                        return [4 /*yield*/, response.arrayBuffer()];
                    case 3:
                        buffer = _b.apply(_a, [_c.sent()]);
                        return [3 /*break*/, 7];
                    case 4: return [4 /*yield*/, response.blob()];
                    case 5:
                        blob = _c.sent();
                        return [4 /*yield*/, blobToBuffer(blob)];
                    case 6:
                        buffer = _c.sent();
                        _c.label = 7;
                    case 7:
                        font = fontkit.create(buffer);
                        this.status = FONT_STATUS.LOADED;
                        this.font = font;
                        this.emit('loaded');
                        VERBOSE && console.log("loaded font ".concat(this.sourceUrl));
                        return [3 /*break*/, 9];
                    case 8:
                        e_1 = _c.sent();
                        this.status = FONT_STATUS.FAILED;
                        this.emit('error');
                        console.log("unable to load font ".concat(this.sourceUrl));
                        throw e_1;
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    FontLoader.prototype.onLoaded = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.loaded()) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, new Promise(function (resolve, reject) {
                                _this.on('loaded', function () {
                                    resolve();
                                });
                                _this.on('error', function () {
                                    reject();
                                });
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    FontLoader.prototype.loaded = function () {
        return this.status === FONT_STATUS.LOADED;
    };
    return FontLoader;
}(PIXI.utils.EventEmitter));
export { FontLoader };
function blobToBuffer(blob) {
    return new Promise(function (resolve, reject) {
        if (typeof Blob === 'undefined' || !(blob instanceof Blob)) {
            reject(new Error('first argument must be a Blob'));
        }
        var reader = new FileReader();
        function onLoadEnd(e) {
            reader.removeEventListener('loadend', onLoadEnd, false);
            if (e.error) {
                reject(e.error);
            }
            else {
                // @ts-ignore
                resolve(Buffer.from(reader.result));
            }
        }
        reader.addEventListener('loadend', onLoadEnd, false);
        reader.readAsArrayBuffer(blob);
    });
}
